var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThryvBigT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 27,
    viewBox: "0 0 12 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.331 23.5801V26.9894C9.09278 26.9425 6.92773 27.1858 4.77488 26.5863C2.3294 25.9069 0.746117 24.3899 0.277575 21.8512C0.11733 20.9806 0.0163067 20.0926 0.0163067 19.2047C-0.0133038 15.1959 0.00411412 0.241536 0.0163067 0H4.51883C4.51883 0.0642937 4.51883 3.01833 4.51883 6.54058H11.2178V10.0281H4.51883C4.50142 13.1594 4.50142 16.1846 4.51883 17.6182C4.51883 18.3463 4.59547 19.0744 4.6965 19.7851C4.99957 22.0944 6.19792 23.2239 8.51276 23.4377C9.43765 23.5141 10.3747 23.5315 11.331 23.5801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThryvBigT);
export default __webpack_public_path__ + "static/media/THRYV_BIG-t.2c08e970550992bb9480ced2a5d2ca05.svg";
export { ForwardRef as ReactComponent };